import { computed, isRef, type Ref } from 'vue';

import { findCheckedChildren } from '../../filter.utilities';

import type { TreeViewItemType } from '#components/treeView';
import type { TreeView } from './useProductData';

type UndefinableTreeViewItemType = TreeViewItemType | undefined;

export function useSelectedTreeviewItemLabels(
  treeView: Ref<UndefinableTreeViewItemType | TreeView> | UndefinableTreeViewItemType | TreeView
) {
  return computed(() => {
    const value = isRef(treeView) ? treeView.value : treeView;
    if (!value || typeof value !== 'object' || !('nodeId' in value && 'label' in value)) {
      return [];
    }
    return findCheckedChildren(value as TreeViewItemType).map((item) => item.label);
  });
}
